"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactFiles = _interopRequireDefault(require("react-files")),
    _reactSizeme = require("react-sizeme"),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _constants = require("../../../constants");

require("../styles/_drop-zone.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var MIN_FILE_SIZE = 0,
    FILE_SIZE_MULTIPLIER = 1e10,
    MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER,
    DropZone = function (a) {
  function b() {
    var a, d;
    (0, _classCallCheck2["default"])(this, b);

    for (var e = arguments.length, f = Array(e), g = 0; g < e; g++) {
      f[g] = arguments[g];
    }

    return (0, _possibleConstructorReturn2["default"])(d, (a = d = c.call.apply(c, [this].concat(f)), d.onFilesChange = function (a) {
      var b = d.props,
          c = b.addFileToQueue,
          e = b.closeDropZone;
      Array.from(a).forEach(function (a) {
        c({
          file: a
        }), d._filePickerRef.removeFiles();
      }), e();
    }, d.setFilePickerRef = function (a) {
      if (!d._filePickerRef && a) {
        var b = d.props.filePickerRefCallBack;
        d._filePickerRef = a, b(a);
      }
    }, d.handleUploadClick = function () {
      d._filePickerRef && d._filePickerRef.openFileChooser();
    }, a));
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.isVisible,
          d = b.handleDragOut;
      return _react["default"].createElement(_reactSizeme.SizeMe, null, function (b) {
        var e = b.size;
        return _react["default"].createElement("div", {
          className: "library-drop-zone__container",
          onDragLeave: d
        }, _react["default"].createElement(_reactFiles["default"], {
          className: (0, _classnames["default"])("library-drop-zone", {
            "library-drop-zone--hidden": !c,
            "library-drop-zone--small": e.width < _constants.mediaSizes.small
          }),
          dropActiveClassName: "library-drop-zone--active",
          onChange: a.onFilesChange,
          onError: console.error,
          accepts: void 0,
          multiple: !0,
          maxFileSize: MAX_FILE_SIZE_GB,
          minFileSize: MIN_FILE_SIZE,
          ref: a.setFilePickerRef,
          clickable: !1
        }, _react["default"].createElement("p", {
          className: "library-drop-zone__primary-text"
        }, "Drag & Drop"), _react["default"].createElement("p", {
          className: "library-drop-zone__secondary-text"
        }, "Drop any .jpg, .png, .gif, .mp4, .mov or\xA0", _react["default"].createElement(_uiKit.Link, {
          onClick: a.handleUploadClick
        }, _react["default"].createElement("u", {
          className: "library-drop-zone__text-underlined"
        }, "browse your files")))));
      });
    }
  }]), b;
}(_react.Component);

exports["default"] = DropZone;